<ng-template
  #confirmUnsavedChangesNavigation
>
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-basic-title"
    >{{'edit-profile.unsaved-changes-dialog.title'|translate}}</h4>
    <button
      type="button"
      class="close"
      attr.aria-label="{{'edit-profile.unsaved-changes-dialog.close-button.aria-label'|translate}}"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{'edit-profile.unsaved-changes-dialog.info-paragraph'|translate}}
    </p>
  </div>
  <div class="modal-footer flex-row-reverse">
    <button
      type="button"
      class="btn btn-danger"
      ngbAutofocus
      (click)="modal.close('discard')"
    >{{'edit-profile.unsaved-changes-dialog.discard-button.label'|translate}}</button>
    <button
      type="button"
      class="btn btn-secondary mr-auto"
      (click)="modal.close('cancel')"
    >{{'edit-profile.unsaved-changes-dialog.cancel-button.label'|translate}}</button>
  </div>
</ng-template>
<div
  class="card standalone fade edit-profile-component"
  [ngClass]="{
    'show': isReady()
  }"
>
  <div class="card-header text-center">
    <h1 class="mb-0">
      {{'edit-profile.title'|translate}}
    </h1>
  </div>
  <form
    [formGroup]="profileForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="card-body">
      <ul
        class="nav nav-tabs nav-fill"
        *ngIf="profile"
      >
        <li class="nav-item">
          <a
            class="nav-link d-flex align-items-center flex-row"
            [ngClass]="{
              'active':  activeTab === 'profile'
            }"
            tabindex="0"
            role="tab"
            placement="auto"
            [ngbTooltip]="profileForm.get('personal').dirty ? ('edit-profile.personal-tab.tooltip.unsaved'|translate) : ('edit-profile.personal-tab.tooltip.default'|translate)"
            (keyup.enter)="changeTab('profile')"
            (click)="changeTab('profile')"
          >
            <span class="icon highlight fa fa-2x fa-fw fa-user"></span>
            <span
              class="tab-notification fa fa-exclamation-circle rounded-circle text-warning border"
              *ngIf="profileForm.get('personal').dirty"
            ></span>
            <div class="tab-label">
              {{'edit-profile.personal-tab.label'|translate}}
            </div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link d-flex align-items-center flex-row"
            [ngClass]="{
              'active':  activeTab === 'contact'
            }"
            tabindex="0"
            role="tab"
            placement="auto"
            [ngbTooltip]="profileForm.get('contact').dirty ? ('edit-profile.contact-tab.tooltip.unsaved'|translate) : ('edit-profile.contact-tab.tooltip.default'|translate)"
            (keyup.enter)="changeTab('contact')"
            (click)="changeTab('contact')"
          >
            <span class="icon highlight fa fa-2x fa-fw fa-address-book"></span>
            <span
              class="tab-notification fa fa-exclamation-circle rounded-circle bg-white text-warning border border-white"
              *ngIf="profileForm.get('contact').dirty"
            ></span>
            <div class="tab-label">
              {{'edit-profile.contact-tab.label'|translate}}
            </div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link d-flex align-items-center flex-row"
            [ngClass]="{
              'active':  activeTab === 'login'
            }"
            tabindex="0"
            role="tab"
            placement="auto"
            ngbTooltip="{{'edit-profile.login-tab.tooltip'|translate}}"
            (keyup.enter)="changeTab('login')"
            (click)="changeTab('login')"
          >
            <span class="icon highlight fa fa-2x fa-fw fa-user-lock"></span>
            <span
              class="tab-notification fa fa-exclamation-circle rounded-circle bg-white text-warning border border-white"
              *ngIf="profileForm.get('login').dirty"
            ></span>
            <div class="tab-label">
              {{'edit-profile.login-tab.label'|translate}}
            </div>
          </a>
        </li>
      </ul>
      <div
        #tabHolder
        class="tab-content"
      >
        <div #profileTab id="profile" class="tab-pane {{activeTab === 'profile' ? 'active' : ''}}">
          <fieldset
            class="pt-3"
            formGroupName="personal"
          >
            <div
              app-form-input
              field="firstName"
              autocomplete="given-name"
              label="{{'edit-profile.first-name.label'|translate}}"
              [isInvalid]="isFieldInvalid('personal.firstName')"
              [isValid]="isFieldValid('personal.firstName')"
            >
              <div
                app-form-input-feedback
                type="invalid"
              >{{'edit-profile.first-name.error-message.required'|translate}}</div>
            </div>
            <div
              app-form-input
              field="lastName"
              autocomplete="family-name"
              label="{{'edit-profile.last-name.label'|translate}}"
              [isInvalid]="isFieldInvalid('personal.lastName')"
              [isValid]="isFieldValid('personal.lastName')"
            >
              <div
                app-form-input-feedback
                type="invalid"
              >{{'edit-profile.last-name.error-message.required'|translate}}</div>
            </div>
            <div
              app-form-input
              field="nickname"
              autocomplete="nickname"
              label="{{'edit-profile.nickname.label'|translate}}"
              [isInvalid]="isFieldInvalid('personal.nickname')"
              [isValid]="isFieldValid('personal.nickname')"
            ></div>
            <div
              app-form-input
              field="preferredUsername"
              autocomplete="displayname"
              label="{{'edit-profile.preferredUsername.label'|translate}}"
              [isInvalid]="isFieldInvalid('personal.preferredUsername')"
              [isValid]="isFieldValid('personal.preferredUsername')"
            ></div>
            <div
              app-form-input
              class="mb-0"
              field="professionalTitle"
              autocomplete="organization-title"
              label="{{'edit-profile.professionalTitle.label'|translate}}"
              [isInvalid]="isFieldInvalid('personal.professionalTitle')"
              [isValid]="isFieldValid('personal.professionalTitle')"
            ></div>
          </fieldset>
        </div>
        <div #contactTab id="contact" class="tab-pane  {{activeTab === 'contact' ? 'active' : ''}}">
          <fieldset
            class="pt-3"
            formGroupName="contact"
          >
            <div
              app-form-input
              field="phoneNumber"
              autocomplete="tel"
              label="{{'edit-profile.phone-number.label'|translate}}"
              [isInvalid]="isFieldInvalid('contact.phoneNumber')"
              [isValid]="isFieldValid('contact.phoneNumber')"
            ></div>
            <div formGroupName="address">
              <div
                app-form-input
                field="streetAddress"
                autocomplete="address-line1"
                label="{{'edit-profile.street-address.label'|translate}}"
                [isInvalid]="isFieldInvalid('contact.address.streetAddress')"
                [isValid]="isFieldValid('contact.address.streetAddress')"
              ></div>
              <div
                app-form-input
                field="postalCode"
                autocomplete="postal-code"
                label="{{'edit-profile.postal-code.label'|translate}}"
                [isInvalid]="isFieldInvalid('contact.address.postalCode')"
                [isValid]="isFieldValid('contact.address.postalCode')"
              ></div>
              <div
                app-form-input
                field="region"
                autocomplete="address-level1"
                label="{{'edit-profile.region.label'|translate}}"
                [isInvalid]="isFieldInvalid('contact.address.region')"
                [isValid]="isFieldValid('contact.address.region')"
              ></div>
              <div
                app-form-input
                field="locality"
                autocomplete="address-level2"
                label="{{'edit-profile.locality.label'|translate}}"
                [isInvalid]="isFieldInvalid('contact.address.locality')"
                [isValid]="isFieldValid('contact.address.locality')"
              ></div>
              <div
                app-form-input
                field="country"
                type="select"
                autocomplete="country"
                label="{{'edit-profile.country.label'|translate}}"
                [isInvalid]="isFieldInvalid('contact.address.country')"
                [isValid]="isFieldValid('contact.address.country')"
                [selectOptions]="resolveCountryOptions({label: ('edit-profile.country.select-option'|translate), value: null})"
              ></div>
            </div>
          </fieldset>
        </div>
        <div #loginTab id="login" class="tab-pane  {{activeTab === 'login' ? 'active' : ''}}" >
          <fieldset
            class="pt-3"
            formGroupName="login"
          >
            <div
              app-form-input
              field="email"
              autocomplete="email"
              label="{{'edit-profile.email.label'|translate}}"
              readonly
              [append]="email_append"
              placement="auto"
              container="body"
              ngbTooltip="{{'edit-profile.email.tooltip'|translate}}"
            >
              <ng-template #email_append>
                <button
                  type="button"
                  class="btn btn-secondary"
                  disabled
                  (click)="changeEmail()"
                >{{'edit-profile.email.change-button.label'|translate}}
                </button>
              </ng-template>
            </div>
            <div
              app-form-input
              field="password"
              autocomplete="password"
              label="{{'edit-profile.password.label'|translate}}"
              readonly
              [append]="pwd_append"
            >
              <ng-template #pwd_append>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="changePWD()"
                >{{'edit-profile.password.change-button.label'|translate}}
                </button>
              </ng-template>
            </div>
            <div
              app-form-input
              class="mb-0"
              field="totp"
              label="{{'edit-profile.totp.label'|translate}}"
              readonly
              [prepend]="totp_prepend"
              [append]="totp_append"
            >
              <ng-template #totp_prepend>
                <span class="icon input-group-text bg-success border-success text-white" *ngIf="totpActive">
                  <span class="fa fa-fw fa-check"></span>
                </span>
                <span class="icon input-group-text bg-danger border-danger text-white" *ngIf="!totpActive">
                  <span class="fa fa-fw fa-ban"></span>
                </span>
              </ng-template>
              <ng-template #totp_append>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="configureTotp()"
                >{{'edit-profile.totp.configure-button.label'|translate}}
                </button>
              </ng-template>
            </div>
          </fieldset>
        </div>
      </div>
      <app-duke-alert
        type="danger"
        *ngIf="hasError()"
        alertClass="mb-0"
        dismissible="true"
        (open)="alertHandler.onOpen($event);"
        (close)="alertHandler.onClose($event); submitFailed = false;"
      >
        <p class="mb-0">
          {{'edit-profile.submit-error.message'|translate}}
        </p>
      </app-duke-alert>
    </div>
    <div class="card-footer">
      <div class="d-flex align-items-center flex-row-reverse">
        <div
          placement="top-right auto"
          container="body"
          [ngbTooltip]="!profileForm.valid ? ('edit-profile.apply-button.tooltip.invalid'|translate) : (!profileForm.dirty ? ('edit-profile.apply-button.tooltip.no-changes'|translate) : null)"
        >
          <button
            class="btn btn-success"
            type="submit"
            [disabled]="!profileForm.valid || !profileForm.dirty"
          >
            {{'edit-profile.apply-button.label'|translate}}
          </button>
        </div>
        <span
          class="text-danger order-2 mr-2"
          *ngIf="hasError()"
          [@cardFooterFeedbackTransition]
        >
          <span class="icon fa fa-fw fa-exclamation-triangle"></span>
          <span>
            {{'edit-profile.submit-error.notification'|translate}}
          </span>
        </span>
        <a
          href="javascript:void(0);"
          (click)="cancel()"
          class="btn btn-secondary order-3 mr-auto"
        >
          {{ profileForm.dirty ? ('edit-profile.cancel-button.label'|translate) : ('edit-profile.close-button.label'|translate)}}
        </a>
      </div>
    </div>
  </form>
</div>
